import React from 'react';

import { Card, Divider, Flex, Stack, Text, Tooltip } from '@mantine/core';

// import { numberWithCommas } from './../../helper/Helper';

interface SummaryCardProps {
  cardText: string;
  cardValue: number | undefined | string | string[] | null;
  cardInfo?: string;
}
export function SummaryCard(props: SummaryCardProps) {
  return (
    <Card
      withBorder
      p="xs"
      style={{
        height: '100%',
        borderRadius: 5,
      }}
    >
      <Flex direction="column" h="100%">
        <Stack style={{ flex: 1 }}>
          {props.cardInfo ? (
            <Tooltip label={props.cardInfo} classNames={{ tooltip: 'help-tooltip', arrow: 'help-tooltip-arrow' }} withinPortal>
              <Text ta="center" fw={500} c="dimmed" style={{ textDecoration: 'underline dotted', textUnderlineOffset: 3 }}>
                {props.cardText}
              </Text>
            </Tooltip>
          ) : (
            <Text ta="center" fw={500} c="dimmed">
              {props.cardText}
            </Text>
          )}
        </Stack>
        <Divider my="xs" />

        <Text ta="center" fw={500} data-testid="summary-card">
          {props.cardValue || '-'}
        </Text>
      </Flex>
    </Card>
  );
}
